export enum VariableMode {
  CALC = 'CALC',
  READ = 'READ',
  WRITE = 'WRITE',
}
